import React, { Fragment, useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Progress,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Button,
  Modal,
  CardTitle,
  Form,
} from "reactstrap"
import { withRouter } from "react-router"

import { Slide, toast, ToastContainer } from "react-toastify"
import Select from "react-select"

const ParametreAuto = props => {
  const [loading, setLoading] = useState(false)
  // Data Table
  const [orders, setOrders] = useState([])
  const [delet, setDelet] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [excel, setExcel] = useState(0)
  const [annee, setAnnee] = useState("")
  const [add, setAdd] = useState(0)
  const [uploadPercent, setUploadPercent] = useState(0)
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 10,
      },
      {
        text: "150",
        value: 150,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const [stopped, setStopped] = useState(false)
  const [message, setMessage] = useState("")
  const [display, setDisplay] = useState("none")
  const [selectDepartement, setSelectDepartement] = useState("")
  const [nbrHeureSeance, setNbrHeureSeance] = useState([
    { value: 60, label: "1h" },
    { value: 90, label: "1h:30" },
  ])
  const [selectNbrHeureSeance, setSelectNbrHeureSeance] = useState("")
  const [quartPause, setQuartPause] = useState([])
  const [selectQuartPause, setSelectQuartPause] = useState("")
  const [quartFinJournee, setQuartFinJournee] = useState([])
  const [selectQuartFinJournee, setSelectQuartFinJournee] = useState("")
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "heur_pause",
      text: "Quart début de pause",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "duree_pause",
      text: "Durée de pause",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
    },
    {
      dataField: "heureFinJournee",
      text: "Quart fin journée",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
    },
  ]

  const { SearchBar } = Search
  const save = async () => {
    if (selectQuartPause === "") {
      toast.error("⛔ Type obligatoire !", {
        containerId: "A",
      })
    } else if (selectQuartFinJournee === "") {
      toast.error("⛔ Matière obligatoire !", {
        containerId: "A",
      })
    } else if (selectNbrHeureSeance !== "") {
      const resVerif = await API.post("emploi/add_pause", {
        semestre_id: props.semestre,
        annee_id: annee_id,
        heureFinJournee: selectQuartFinJournee.label,
        heur_pause: selectQuartPause.label,
        duree_pause: selectNbrHeureSeance.value,
      }).then(resVerif => {
        setSelectQuartFinJournee("")
        setSelectQuartPause("")
        setSelectNbrHeureSeance("")
        API.post("emploi/getlistparametrage", {
          annee_id,semestre_id:props.semestre.value
        }).then(resList => {
          setOrders(resList.data.parametrages)
        })
      })
    } else {
      toast.error("⛔ Groupe obligatoire !", {
        containerId: "A",
      })
    }
  }
  useEffect(async () => {
    setOrders([])
    setUploadPercent(0)
    setSelectQuartFinJournee("")
    setSelectQuartPause("")
    setSelectNbrHeureSeance("")
    const fetchAnnee = async () => {
      const resD = await API.post("annee/get_by_id", { id: annee_id })
      setAnnee(resD.data.Annee.annee_scolaire)
    }
    await fetchAnnee()
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Emploi enseignant")
    )
    setAdd(typeArticleSubMenu.sous_menu[0].add)
    setDelet(typeArticleSubMenu.sous_menu[0].delete)
    setExcel(typeArticleSubMenu.sous_menu[0].exel)
    setLoading(true)
    const resQuartPause = await API.get("emploi/get_quart").then(
      resQuartPause => {
        setQuartPause(resQuartPause.data.formatted)
      }
    )
    const resQuartFin = await API.get("emploi/get_quart_fin").then(resQuartFin => {
      setQuartFinJournee(resQuartFin.data.formatted)
    })
    const resList = await API.post("emploi/getlistparametrage", {
      annee_id,semestre_id:props.semestre.value
    }).then(resList => {
      setOrders(resList.data.parametrages)
    })
  }, [props.semestre, stopped])
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row>
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <Fragment>
                    <Row style={{ marginTop: "15px" }}>
                      <CardTitle style={{ color: "#556ee6" }} className="h4">
                        Ajouter un paramètrege de séance
                      </CardTitle>
                      <Form className="mt-4">
                        <Row>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-lastname-input2">
                                Quart début de pause :
                              </Label>
                              <Select
                                options={quartPause}
                                isSearchable={true}
                                value={selectQuartPause}
                                onChange={e => setSelectQuartPause(e)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-lastname-input2">
                                Durée de pause :
                              </Label>
                              <Select
                                options={nbrHeureSeance}
                                isSearchable={true}
                                value={selectNbrHeureSeance}
                                onChange={e => setSelectNbrHeureSeance(e)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-lastname-input2">
                                Quart fin journée :
                              </Label>
                              <Select
                                options={quartFinJournee}
                                isSearchable={true}
                                value={selectQuartFinJournee}
                                onChange={e => setSelectQuartFinJournee(e)}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                      <Row>
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {" "}
                          <Col lg="6">
                            <div className="text-center mt-4">
                              <button
                                type="button"
                                className="btn btn-primary "
                                onClick={save}
                              >
                                SAUVGARDER
                              </button>
                            </div>
                          </Col>
                        </div>
                      </Row>
                    </Row>
                    <div style={{ marginTop: "15px" }}>
                      <CardTitle style={{ color: "#556ee6" }} className="h4">
                        Liste des paramètreges de séance
                      </CardTitle>
                      <Fragment>
                        <Col sm="4">
                          <div className="search-box me-2 mb-2 d-inline-block">
                            <div className="position-relative">
                              <SearchBar {...toolkitProps.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                        <BootstrapTable
                          wrapperClasses="table-responsive"
                          noDataIndication={() => <NoDataIndication />}
                          striped={false}
                          bordered={false}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"table-light"}
                          hover
                          pagination={paginationFactory(pageOptions)}
                          {...toolkitProps.baseProps}
                        />
                      </Fragment>
                    </div>
                  </Fragment>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              En cours ...{" "}
            </h4>
          </div>
        )}
      </div>

      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withRouter(ParametreAuto)
ParametreAuto.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  semestre: PropTypes.object,
}
